module.exports = __webpack_public_path__ + "static/media/logo-buyuk6.6e94ba0b.png";